import { useState } from "react";

/**
 * Cards with photos, or a compact list without: one choice for every screen
 * that shows a list of items, so switching on Items also switches Locations.
 *
 * Remembered per device. Unset, a stockroom starts as a list: its items mostly
 * came in on an invoice and were never photographed.
 */

export type ItemView = "cards" | "list";

const VIEW_KEY = "utucat.itemsView";

function readView(stock: boolean): ItemView {
  try {
    const kept = window.localStorage.getItem(VIEW_KEY);
    if (kept === "cards" || kept === "list") return kept;
  } catch {
    // Storage can be blocked; the default is fine.
  }
  return stock ? "list" : "cards";
}

export function useItemView(stock: boolean): [ItemView, (next: ItemView) => void] {
  const [view, setView] = useState<ItemView>(() => readView(stock));
  const choose = (next: ItemView) => {
    setView(next);
    try {
      window.localStorage.setItem(VIEW_KEY, next);
    } catch {
      // Not remembered, still applied.
    }
  };
  return [view, choose];
}
